import { getTimeStamp } from '@/utils/sign'
const getDefaultState = () => {
    return {
        // 会话列表
        conversationList: [],
        // token
        token: null,
        // 当前用户userId
        userId: null,
        // 当前会话选中信息
        customerInfo: {},
        // 历史记录
        history: [],
        // 群的@消息集合  数据结构  targertId:{messageId:{}}
        mentionedGroups: {},
        // 是否显示聊天
        globalShowChat: false,
        // 是否显示我的商品
        showCommodity: false,
        // 大图合集
        previewList: [],
        // 全部未读数
        allUnreadCount: 0,
        // 自动回复次数
        count: 0,
        // 是否已经初始化
        initFinish: false,
        // 是否显示新消息
        isNewMessage: false,
        // 咨询信息
        consult: null,
        // 订单流转信息
        orderFlow: [],
        orderImGoods: null,
        orderFlowShow: false,
        // 记录消息发送
        ryInputIdList: [],
        rySendReadReceipt: [],
        // 记录自动回复状态
        usercsWorkAutoSend: true,
        // 聊天会话筛选
        conversationActive: 0,
        // 工单卡片
        workOrderCardData: null,
        // 工单扭转卡片
        newNodeCard: null,
        // 单聊已读记录
        imSingleChat: [],
        // 商品咨询信息
        goodsConsult: null,
        // 临时协议
        agreementInfo: {},
        // 3.5工单节点
        refreshWorkOrder35Progress: false,
        workOrder35Progress: [],
        // 订单信息
        imOrderInfo: {},
        // 扩展消息
        imExpansion: {},
        // 当前激活的会话
        activeConversationType: null,
        // 回收号商信息（用于埋点）
        recycleMerchantInfo: null,
    }
}
export const state = () => ({
    ...getDefaultState()
})
export const mutations = {
    // 设置当前激活的会话
    SET_ACTIVE_CONVERSATION_TYPE: (state, type) => {
        state.activeConversationType = type
    },
    // 会话列表
    SET_CONVERSATION_LIST: (state, list) => {
        const arr = list.length > 0 ? JSON.parse(JSON.stringify(list)) : []
        state.conversationList = arr
    },
    // token
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    // userId
    SET_USER_ID: (state, userId) => {
        state.userId = userId
    },
    // 设置当前会话选中信息
    SET_CUSTOMER_INFO: (state, info) => {
        state.customerInfo = info
    },
    // 设置历史记录
    SET_HISTORY: (state, list) => {
        state.history = list
    },
    // 清空数据
    REMOVE_MENTIONEDGROUPS_LIST: (state, obj) => {
        state.mentionedGroups = obj
    },
    // 修改数据
    SET_MENTIONEDGROUPS_LIST: (state, obj) => {
        state.mentionedGroups = obj
    },
    // 是否显示聊天
    SET_GLOBAL_SHOW_CHAT: (state, bool) => {
        state.globalShowChat = bool
    },
    // 是否显示我的商品
    SET_GLOBAL_SHOW_COMMODITY: (state, bool) => {
        state.showCommodity = bool
    },
    // 消息中的图片列表
    SET_PREVIEW_LIST: (state, list) => {
        state.previewList = list
    },
    // 消息未读数
    SET_ALL_UNREAD_COUNT: (state, count) => {
        state.allUnreadCount = count
    },
    // 自动回复数
    SET_COUNT: (state, count) => {
        state.count = count
    },
    // 修改会话列表初始化状态
    SET_INIT_STATUS: (state, status) => {
        state.initFinish = status
    },
    SET_IS_NEW_MESSAGE: (state, bool) => {
        state.isNewMessage = bool
    },
    // 咨询信息
    SET_CONSULT: (state, info) => {
        state.consult = info
    },
    // 订单流转
    SET_ORDER_FLOW: (state, data) => {
        state.orderFlow = data
    },
    // 订单流转商品
    SET_ORDER_GOODS: (state, data) => {
        state.orderImGoods = data
    },
    // 订单流转是否显示
    SET_ORDER_FLOW_SHOW: (state, b) => {
        state.orderFlowShow = b
    },
    // 防止回执重复发送的处理
    SET_INPUTID_LIST: (state, data) => {
        state.ryInputIdList = data
    },
    // 消息回执列表的处理
    SET_RY_SEND_READ: (state, data) => {
        state.rySendReadReceipt = data
    },
    // 记录自动回复状态
    SET_WORK_AUTO_SEND: (state, data) => {
        state.usercsWorkAutoSend = data
    },
    // 聊天会话筛选
    SET_CONVERSATION_ACTIVE: (state, data) => {
        state.conversationActive = data
    },
    // 工单卡片
    SET_WORK_CARD_DATA: (state, data) => {
        state.workOrderCardData = data
    },
    // 工单卡片
    SET_NEW_NODE_CARD: (state, data) => {
        state.newNodeCard = data
    },
    // 3.5工单节点
    SET_WORKORDER35_PROGRESS: (state, data) => {
        state.workOrder35Progress = data
    },
    // 刷新3.5工单节点
    SET_REFRESH_WORKORDER35_PROGRESS: (state, data) => {
        state.refreshWorkOrder35Progress = data
    },
    // 订单信息
    SET_IM_ORDER_INFO: (state, data) => {
        state.imOrderInfo = data
    },
    // 单聊已读记录
    SET_IM_SINGLECHAT: (state, data) => {
        state.imSingleChat = data
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
    // 商品咨询信息
    SET_GOODS_CONSULT: (state, data) => {
        state.goodsConsult = data
    },
    // 临时协议
    SET_AGREEMENT_INFO: (state, data) => {
        state.agreementInfo = data
    },
    // 扩展消息
    SET_IM_EXPANSION: (state, data) => {
        state.imExpansion = {
            ...state.imExpansion,
            [data.messageUId]: data.expansion
        }
    },
    // 设置回收号商信息
    SET_RECYCLE_MERCHANT_INFO: (state, data) => {
        state.recycleMerchantInfo = data
    }
}

export const actions = {
    // 初始化链接
    initConnect({ commit, dispatch }, token) {
        // 赋值token
        commit('SET_TOKEN', token)
        this.$RongIMLib.connect(token).then(({ code, data }) => {
            if (!code) {
                commit('SET_USER_ID', data.userId)
                // dispatch('initConversationList')
            } else if (code == 31004) {
                // token过期或失效，重新获取
                this.$api.getImInfo().then(({ success, data }) => {
                    if (success) {
                        dispatch('initConnect', data)
                    }
                })
            }
        })
    },
    // 初始化会话列表
    initConversationList({ commit, dispatch }) {
        return new Promise(resolve => {
            this.$RongIMLib.getConversationList({ count: 300 }).then(({ data, code }) => {
                if (!code) {
                    // 完善信息
                    dispatch('completeInfo', data).then(list => {
                        let count = 0
                        const oldList = [...list]
                        console.log('会话列表:', list)
                        oldList.map(oldItem => {
                            const oldCount = oldItem.unreadMessageCount
                            count += oldCount || 0
                        })
                        commit('SET_ALL_UNREAD_COUNT', count)
                        commit('SET_CONVERSATION_LIST', list)
                        commit('SET_INIT_STATUS', true)
                        resolve()
                    })
                }
            })
        })
    },
    // 更新会话列表
    async updateConversationList({ commit, state, dispatch }, info) {
        if (!state.initFinish) {
            return
        }
        // 已有的会话列表
        const oldList = [...state.conversationList]
        // isFind 用来判断是否为新会话
        let isFind = true
        const newList = []
        // 循环已有会话列表
        for (let index = 0; index < oldList.length; index++) {
            const element = oldList[index]
            // 判断收到的会话是否在会话列表存在
            if (element.targetId == info.targetId) {
                // 如果存在就删除原有的会话
                oldList.splice(index, 1)
                // 再将收到的会话插入到会话列表的第一条
                if (info.latestMessage) {
                    oldList.unshift({ ...element, ...info })
                } else if (info.content?.content) {
                    oldList.unshift({ ...element, orderNo: info.content?.content?.orderNo ? info.content.content.orderNo : element.orderNo, latestMessage: info })
                } else {
                    oldList.unshift({ ...element, latestMessage: info })
                }
                // 将 isFind 设置为 false
                isFind = false
                // 更新 store 中会话列表数据
                commit('SET_CONVERSATION_LIST', oldList)
                break
            }
        }
        // 如果 收到的会话在会话列表中不存在，就执行以下处理
        if (isFind) {
            // 通过后端接口获取收到会话的相关数据并重组
            const arr = await dispatch('completeInfo', [{ ...info }])
            // 将新收到的会话插入到会话列表第一条
            oldList.unshift({
                ...arr[0],
                ...info
            })
            commit('SET_CONVERSATION_LIST', oldList)
        }

        let count = 0
        oldList.map(oldItem => {
            const oldCount = oldItem.unreadMessageCount
            count += oldCount || 0
        })
        commit('SET_ALL_UNREAD_COUNT', count)
        // commit('SET_CONVERSATION_LIST', newList)
        // });
    },
    // 清除未读数
    clearUnreadCount({ commit, state }) {
        const conversationType = state.customerInfo.conversationType
        const targetId = state.customerInfo.targetId
        const oldList = [...state.conversationList]
        this.$RongIMLib
            .clearMessagesUnreadStatus({
                conversationType,
                targetId
            })
            .then(res => {
                if (res.code === 0) {
                    // 发送多端同步未读数消息
                    this.$RongIMLib.sendSyncReadStatusMessage({ conversationType, targetId }, Date.now())
                    let count = 0
                    oldList.map(oldItem => {
                        if (oldItem.targetId == targetId) {
                            oldItem.unreadMessageCount = 0
                        } else {
                            const oldCount = oldItem.unreadMessageCount
                            count += oldCount || 0
                        }
                    })
                    commit('SET_ALL_UNREAD_COUNT', count)
                    commit('SET_CONVERSATION_LIST', oldList)
                }
            })
    },
    // 清除未读数
    clearUnreadCountCopy({ commit, state }) {
        const conversationType = state.customerInfo.conversationType
        const targetId = state.customerInfo.targetId
        const oldList = [...state.conversationList]
        let count = 0
        oldList.map(oldItem => {
            if (oldItem.targetId == targetId) {
                oldItem.unreadMessageCount = 0
            } else {
                const oldCount = oldItem.unreadMessageCount
                count += oldCount || 0
            }
        })
        commit('SET_ALL_UNREAD_COUNT', count)
        commit('SET_CONVERSATION_LIST', oldList)
    },
    updateGroupMentionedInfo({ commit, state }, msgList) {
        const _newMentGoups = {}
        let _markIndex = 0
        msgList.forEach(msgItem => {
            // 只有未读消息才进入计数
            if (msgItem.receivedStatus != 0) {
                return false
            }
            _markIndex = 0
            for (const key in state.mentionedGroups) {
                if (Object.hasOwnProperty.call(state.mentionedGroups, key)) {
                    const mentItem = state.mentionedGroups[key]
                    if (msgItem.targetId == key) {
                        _newMentGoups[key] = {
                            ...mentItem
                        }
                        _newMentGoups[key][msgItem.messageUId] = {
                            ...msgItem
                        }
                        _markIndex = 1
                    } else {
                        _newMentGoups[key] = {
                            ...mentItem
                        }
                    }
                }
            }
            if (_markIndex === 0) {
                // 没有进入循环，是一个新会话，加入到新的里面
                _newMentGoups[msgItem.targetId] = {}
                _newMentGoups[msgItem.targetId][msgItem.messageUId] = {
                    ...msgItem
                }
            }
            console.log('进来没有试试水', _markIndex)
        })
        console.log('构建的内容_newMentGoups', _newMentGoups)
        commit('SET_MENTIONEDGROUPS_LIST', _newMentGoups)
    },
    // 清理群聊的@ 信息
    clearGroupMentionedInfo({ commit, state }, msgList) {
        commit('SET_MENTIONEDGROUPS_LIST', msgList)
    },
    // 加入
    join({ commit, dispatch }, targetData) {
        return new Promise((resolve, reject) => {
            this.$RongIMLib
                .getConversation({
                    conversationType: targetData.conversationType,
                    targetId: targetData.targetId.toString()
                })
                .then(({ code, data }) => {
                    const newData = data.latestMessage ? data.latestMessage : data
                    if (!code) {
                        dispatch('completeInfo', [data]).then(list => {
                            // 是否是去回收跳转过来的
                            if (targetData.type) {
                                commit('SET_GLOBAL_SHOW_COMMODITY', true)
                            }
                            commit('SET_GLOBAL_SHOW_CHAT', true)
                            // 设置当前会话
                            commit('SET_CUSTOMER_INFO', list[0])
                            // 重置历史列表
                            // commit('SET_HISTORY', []);
                            // 会话列表
                            dispatch('updateConversationList', newData)
                            resolve()
                        })
                    }
                })
        })
    },
    // 发送商品信息
    sendGoodsMsg({ commit, rootState, dispatch, state }, { targetId, content }) {
        dispatch('join', { targetId, conversationType: 1 }).then(() => {
            commit('SET_CONSULT', { targetId, ...content })
        })
    },
    sendGoodsMsg2({ commit, state, rootState, dispatch }) {
        const { goodsNo, price, url, targetId, title } = state.consult
        // 定义消息投送目标会话, 这里定义一个群组类型会话
        const conversation = { conversationType: 1, targetId: targetId.toString() }
        // 实例化待发送消息
        const message = new this.$RongIMLib.TextMessage({
            // 文本内容
            content:
                price && url
                    ? `商品编号：${goodsNo}
    						商品价格：${price}元
    						商品链接：${url}
    					`
                    : `咨询类型：${title}
    				商品编号：${goodsNo}`,
            user: {
                id: String(rootState.user.userinfo.id),
                name: rootState.user.userinfo.nickname,
                portrait: rootState.user.userinfo.headImage
            },
            extra: JSON.stringify({ actualPort: 'PC-官网' })
        })
        // 配置属性
        const options = {
            // 消息发送前的回调，可以使用此回调返回的 message 用于列表渲染
            onSendBefore: message => {
                console.log('消息发送前的回调', message)
            }
        }
        // 发送消息
        this.$RongIMLib.sendMessage(conversation, message, options).then(res => {
            if (res.code === this.$RongIMLib.ErrorCode.SUCCESS) {
                commit('SET_CONSULT', null)
                // 消息发送成功，可以根据返回结果中的 messageId 字段将列表中的该消息状态改为发送成功。
                // 更新聊天窗口数据
                if (res.data.messageType === 'RC:ImgMsg') {
                    const _images = [...state.previewList]
                    _images.push(res.data.content.imageUri)
                    commit('SET_PREVIEW_LIST', _images) // 用于聊天窗口查看大图;
                }
                // 更新历史记录
                // 处理消息的时间显示逻辑
                if (state.history.length > 0) {
                    const _lastMsg = state.history[state.history.length - 1]
                    const gap = res.data.sentTime - _lastMsg.sentTime
                    if (gap < 300000) {
                        res.data.hiddenTime = true
                    }
                }
                // 对单聊没收到回执的情况处理
                if (res.data.conversationType == 1 && state.imSingleChat.filter(item => item.targetId == res.data.targetId).length == 0) {
                    state.imSingleChat.push({
                        targetId: res.data.targetId,
                        messageUId: res.data.messageUId,
                        sendUserId: res.data.sendUserId,
                        startTime: res.data.sentTime,
                        endTime: null
                    })
                    commit('SET_IM_SINGLECHAT', state.imSingleChat)
                }
                commit('SET_HISTORY', [...state.history, { ...res.data }])
                // 更新会话列表
                dispatch('updateConversationList', { ...res.data })
                // 自动回复
                // state.customerInfo.conversationType != 3 &&
                //     this.$api.getCsAuto({ action: { csUserId: state.customerInfo.targetId } }).then(({ success }) => {
                //         if (success) {
                //             commit('SET_COUNT', 1)
                //         }
                //     })
                // 自动回复
                console.log('😂😂')
                dispatch('afterSendMessage', message)
            } else {
                console.log('消息发送失败', res)
            }
        })
    },
    // 发送自定义消息
    sendCustomGoodsMsg({ commit, state, rootState, dispatch }) {
        const data = {
            content: {
                ...state.consult
            },
            extra: JSON.stringify({ actualPort: 'PC-官网' }),
            user: {
                portraitUri: rootState.user.userinfo.headImage,
                portrait: rootState.user.userinfo.headImage,
                id: rootState.user.userinfo.id,
                name: rootState.user.userinfo.nickname
            },
            cardName: state.consult.goodsId
        }
        const PersonMessage = this.$RongIMLib.registerMessageType('panzhi:consultProductMsg', true, true, ['cardName'], false)
        const message = new PersonMessage(data)
        this.$RongIMLib
            .sendMessage(
                {
                    conversationType: state.consult.conversationType ? state.consult.conversationType : this.$RongIMLib.ConversationType.PRIVATE,
                    targetId: state.consult.targetId.toString()
                },
                message
            )
            .then(res => {
                if (res.code === this.$RongIMLib.ErrorCode.SUCCESS) {
                    commit('SET_CONSULT', null)
                    // 消息发送成功，可以根据返回结果中的 messageId 字段将列表中的该消息状态改为发送成功。
                    // 更新聊天窗口数据
                    // 更新历史记录
                    // 处理消息的时间显示逻辑
                    if (state.history.length > 0) {
                        const _lastMsg = state.history[state.history.length - 1]
                        const gap = res.data.sentTime - _lastMsg.sentTime
                        if (gap < 300000) {
                            res.data.hiddenTime = true
                        }
                    }
                    // 对单聊没收到回执的情况处理
                    if (res.data.conversationType == 1 && state.imSingleChat.filter(item => item.targetId == res.data.targetId).length == 0) {
                        state.imSingleChat.push({
                            targetId: res.data.targetId,
                            messageUId: res.data.messageUId,
                            sendUserId: res.data.sendUserId,
                            startTime: res.data.sentTime,
                            endTime: null
                        })
                        commit('SET_IM_SINGLECHAT', state.imSingleChat)
                    }
                    commit('SET_HISTORY', [...state.history, { ...res.data }])
                    // 更新会话列表
                    dispatch('updateConversationList', { ...res.data })

                    // 自动回复
                    console.log('😂😂')
                    dispatch('afterSendMessage', message)
                } else {
                    console.log('消息发送失败', res)
                }
            })
    },
    // 发送订单卡片消息
    sendCustom0rderCardMsg({ commit, state, rootState, dispatch }, info) {
        const data = {
            content: {
                ...state.consult
            },
            user: {
                portraitUri: rootState.user.userinfo.headImage,
                portrait: rootState.user.userinfo.headImage,
                id: rootState.user.userinfo.id,
                name: rootState.user.userinfo.nickname
            },
            extra: JSON.stringify({ actualPort: 'PC-官网' }),
            cardName: state.consult.goodsNo
        }
        const PersonMessage = this.$RongIMLib.registerMessageType(info, true, true, ['cardName'], false)
        const message = new PersonMessage(data)
        this.$RongIMLib
            .sendMessage(
                {
                    conversationType: state.customerInfo.conversationType ? state.customerInfo.conversationType : this.$RongIMLib.ConversationType.PRIVATE,
                    targetId: state.customerInfo.targetId.toString()
                },
                message
            )
            .then(res => {
                if (res.code === this.$RongIMLib.ErrorCode.SUCCESS) {
                    commit('SET_CONSULT', null)
                    // 消息发送成功，可以根据返回结果中的 messageId 字段将列表中的该消息状态改为发送成功。
                    // 更新聊天窗口数据
                    // 更新历史记录
                    // 处理消息的时间显示逻辑
                    if (state.history.length > 0) {
                        const _lastMsg = state.history[state.history.length - 1]
                        const gap = res.data.sentTime - _lastMsg.sentTime
                        if (gap < 300000) {
                            res.data.hiddenTime = true
                        }
                    }
                    // 对单聊没收到回执的情况处理
                    if (res.data.conversationType == 1 && state.imSingleChat.filter(item => item.targetId == res.data.targetId).length == 0) {
                        state.imSingleChat.push({
                            targetId: res.data.targetId,
                            messageUId: res.data.messageUId,
                            sendUserId: res.data.sendUserId,
                            startTime: res.data.sentTime,
                            endTime: null
                        })
                        commit('SET_IM_SINGLECHAT', state.imSingleChat)
                    }
                    commit('SET_HISTORY', [...state.history, { ...res.data }])
                    // 更新会话列表
                    dispatch('updateConversationList', { ...res.data })
                    // 自动回复
                    // state.customerInfo.conversationType != 3 &&
                    //     this.$api.getCsAuto({ action: { csUserId: state.customerInfo.targetId } }).then(({ success }) => {
                    //         if (success) {
                    //             commit('SET_COUNT', 1)
                    //         }
                    //     })
                    // 自动回复
                    dispatch('afterSendMessage', message)
                } else {
                    console.warn('消息发送失败', res)
                }
            })
    },
    afterSendMessage({ dispatch }, message) {
        // @消息不发
        const isAtMessage = Boolean(message?.content?.mentionedInfo)
        if (isAtMessage) { return }

        /** @上班自动回复 **/
        dispatch('workAutoReply')

        /** @下班离线提示 **/
        dispatch('offWorkAutoReply')
    },
    // 上班自动回复
    workAutoReply({ state }) {
        const { conversationType, sentTime, targetId } = state.customerInfo
        // 单聊才发
        if (conversationType !== 1) {
            return
        }

        // 自动回复：欢迎语+离线提示
        const lastMessage = state.history[state.history.length - 1]
        // 欢迎语

        const timeDifference = sentTime - (lastMessage?.sentTime || 0)

        if (timeDifference > 1000 * 60 * 60) {
            const data = {
                action: {
                    csUserId: Number(targetId)
                }
            }
            this.$api.getCsAuto(data)
            console.warn('IM=>发送消息成功:当前消息与上条消息间隔超过1小时, 发送客服自动回复请求')
        }
    },
    // 下班自动回复
    offWorkAutoReply({ state }) {
        const { conversationType, targetId, groupType } = state.customerInfo

        // 私聊
        if (conversationType === 1) {
            // 在下班时间
            this.$api.usercsWorkAutoSend({ action: { csUserId: targetId } })
            console.warn('IM=>发送消息成功:下班消息发送成功')
        }
        // 群聊
        else if (conversationType === 3) {
            // 买卖家群聊、c2c建联 不发消息
            if ([0, 2].includes(groupType)) { return }
            // 在下班时间
            this.$api.usercsWorkAutoSend({ action: { groupId: targetId } })
            console.warn('IM=>发送消息成功:下班消息发送成功')
        }
    },
    // 完善列表信息
    completeInfo({ commit, dispatch, state, rootState }, messageList) {
        return new Promise((resolve, reject) => {
            const userIds = []
            const groupIds = []
            const ERROR_CONVERSATION_LIST = []

            messageList.forEach(item => {
                if (item.conversationType === 1) {
                    if (Number.isNaN(Number(item.targetId)) || String(item.targetId).length > 8) {
                        ERROR_CONVERSATION_LIST.push({ targetId: item.targetId, conversationType: item.conversationType })
                    } else {
                        userIds.push(item.targetId)
                    }
                }
                if (item.conversationType === 3) {
                    if (!Number.isNaN(Number(item.targetId)) && item.targetId.length !== 24) {
                        ERROR_CONVERSATION_LIST.push({ targetId: item.targetId, conversationType: item.conversationType })
                    } else {
                        groupIds.push(item.targetId)
                    }
                }
            })
            if (ERROR_CONVERSATION_LIST.length) {
                console.error('会话列表中存在会话类型错误：', ERROR_CONVERSATION_LIST)
            }

            const list = []
            let _userList = null
            let _groupList = null
            if (userIds.length > 0) {
                _userList = this.$api.findUsers({ action: { userIds } })
            }

            if (groupIds.length > 0) {
                _groupList = this.$api.findGroups({ action: { groupIds } })
            }
            Promise.all([_userList, _groupList]).then(async result => {
                const _tempUserList = (result[0] && result[0].data) || []
                const _tempGroupList = (result[1] && result[1].data) || []
                const allList = _tempUserList.concat(_tempGroupList)

                messageList.map(item => {
                    if (!item.latestMessage) {
                        item.latestMessage = {}
                    }

                    if (item.latestMessage.content && item.latestMessage.content.content) {
                        if (typeof item.latestMessage.content.content == 'string') {
                            item.latestMessage.content.content = item.latestMessage.content.content.replace(/<[^<>]+>/g, '')
                        }
                    }

                    const matchingItem = allList.find(resItem => String(item.targetId) === String(resItem.id))
                    if (matchingItem) {
                        list.push({
                            ...item,
                            ...matchingItem
                        })
                    }
                })
                // 当前时间戳
                let currentDate = new Date()
                const resTime = await getTimeStamp()
                if (resTime) {
                    currentDate = new Date(resTime)
                }

                // 清除 七天内无消息的VIP会话
                const newConversationList = [...list]

                // const res = await this.$api.getVipConversation()
                // if (res.success && res.data?.length) {
                // 	const vipTargetIdList = [...res.data]
                // 	const vipConversationList = newConversationList.filter(el => vipTargetIdList.find(item => item?.toString() == el.targetId?.toString()))

                // 	let customerIds = []
                // 	// 若是会话存在，删除会话
                // 	if (vipConversationList.length) {
                // 		// 当前日期
                // 		const currentDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
                // 		// 七天前的日期
                // 		const sevenDaysAgo = new Date()
                // 		sevenDaysAgo.setDate(currentDay.getDate() - 7)
                // 		// 七天前的时间戳
                // 		const promiseList = vipConversationList.map(async conversation => {
                // 			// 判断最一条消息的时间
                // 			if (conversation?.latestMessage.sentTime) {
                // 				const dateFromTimestamp = new Date(conversation.latestMessage.sentTime)
                // 				const dayFromTimestamp = new Date(dateFromTimestamp.getFullYear(), dateFromTimestamp.getMonth(), dateFromTimestamp.getDate())
                // 				const isSevenDaysAgo = dayFromTimestamp < sevenDaysAgo
                // 				// 大于七天无消息且为单聊
                // 				if (isSevenDaysAgo && conversation.conversationType === 1) {
                // 					const res = await this.$RongIMLib.removeConversation({
                // 						conversationType: conversation.conversationType,
                // 						targetId: conversation.targetId
                // 					})
                // 					return res
                // 				}
                // 			}
                // 		})
                // 		// 异步处理
                // 		const resList = await Promise.all(promiseList)
                // 		resList.map((el, idx) => {
                // 			if (el?.code === 0) {
                // 				customerIds.push(vipConversationList[idx].targetId)
                // 				newConversationList.map((k, i) => {
                // 					if (vipConversationList[idx].targetId === k.targetId) {
                // 						newConversationList.splice(i, 1)
                // 					}
                // 				})
                // 			}
                // 		})
                // 	} else {
                // 		// 若是会话不存在，直接调删除标记接口
                // 		customerIds = [...vipTargetIdList]
                // 	}
                // 	customerIds.length && this.$api.vipConversationDeleteMark({ action: { customerIds } })
                // }
                resolve(newConversationList)
            })
        })
    },
    // 发送小灰条
    sendGrayLineMessage({ commit, state, dispatch }, options) {
        return new Promise(resolve => {
            const grayMessage = new this.$RongIMLib.InformationNotificationMessage({ message: options.message })
            const targetId = options.targetId
            const conversation = {
                // 默认单聊
                conversationType: options.conversationType || 1,
                targetId
            }
            this.$RongIMLib.sendMessage(conversation, grayMessage).then(res => {
                // 更新会话列表
                dispatch('updateConversationList', { ...res.data })
                resolve(res)
            })
        })
    },
    // 订单流转
    setOrderFlow({ commit, state }, data) {
        commit('SET_ORDER_FLOW', data)
    },
    // 订单商品信息
    setOrderGoods({ commit, state }, data) {
        commit('SET_ORDER_GOODS', data)
    },
    reset({ commit }) {
        commit('RESET_STATE')
    }
}
export const getters = {
    activeConversationType: state => state.activeConversationType,
    conversationList: state => state.conversationList,
    token: state => state.token,
    userId: state => state.userId,
    customerInfo: state => state.customerInfo,
    history: state => state.history,
    mentionedGroups: state => state.mentionedGroups,
    globalShowChat: state => state.globalShowChat,
    showCommodity: state => state.showCommodity,
    previewList: state => state.previewList,
    allUnreadCount: state => state.allUnreadCount,
    count: state => state.count,
    initFinish: state => state.initFinish,
    isNewMessage: state => state.isNewMessage,
    consult: state => state.consult,
    orderFlow: state => state.orderFlow,
    orderImGoods: state => state.orderImGoods,
    orderFlowShow: state => state.orderFlowShow,
    ryInputIdList: state => state.ryInputIdList,
    rySendReadReceipt: state => state.rySendReadReceipt,
    usercsWorkAutoSend: state => state.usercsWorkAutoSend,
    conversationActive: state => state.conversationActive,
    workOrderCardData: state => state.workOrderCardData,
    newNodeCard: state => state.newNodeCard,
    imSingleChat: state => state.imSingleChat,
    goodsConsult: state => state.goodsConsult,
    agreementInfo: state => state.agreementInfo,
    workOrder35Progress: state => state.workOrder35Progress,
    refreshWorkOrder35Progress: state => state.refreshWorkOrder35Progress,
    imOrderInfo: state => state.imOrderInfo,
    imExpansion: state => state.imExpansion,
    recycleMerchantInfo: state => state.recycleMerchantInfo
}
